import { useState } from 'react'
import { AiFillStar } from 'react-icons/ai'
import { ratingService } from '../services/rating.service'
import { toast } from '../services/toast.service'

const StarRating = ({ mediaId }) => {
  const [rating, setRating] = useState(() => ratingService.get(mediaId))
  const [hover, setHover] = useState(0)

  const handleSet = (value) => {
    // clicking the same star again clears the rating
    const next = value === rating ? 0 : value
    setRating(next)
    ratingService.set(mediaId, next)
    toast(next ? `You rated this ${next}/5` : 'Rating cleared', 'success')
  }

  return (
    <div className='star-rating'>
      <span className='sr-label'>Your rating</span>
      <div className='sr-stars'>
        {[1, 2, 3, 4, 5].map((value) => (
          <button
            key={value}
            className={`sr-star ${(hover || rating) >= value ? 'on' : ''}`}
            onMouseEnter={() => setHover(value)}
            onMouseLeave={() => setHover(0)}
            onClick={() => handleSet(value)}
            aria-label={`Rate ${value} out of 5`}
          >
            <AiFillStar />
          </button>
        ))}
      </div>
      <span className='sr-value'>{rating ? `${rating}/5` : 'Not rated'}</span>
    </div>
  )
}

export default StarRating
